import React from 'react';
import styled from 'styled-components/macro';
import czoLogo from 'assets/images/czo-logo.png';
import { Tools } from 'components/Tools/Tools';
import { ToolsItem } from 'components/Tools/ToolsItem/ToolsItem';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface IMobileSide {
  onMenuClick: (e?: React.MouseEvent) => void;
}

export const StyledMobileSide = styled.div`
  padding: ${({ theme }) => theme.spacing[4]};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  overflow: auto;

  > * + * {
    margin-top: ${({ theme }) => theme.spacing[3]};
  }
`;

const StyledMobileMenu = styled.nav`
  > * + * {
    margin-top: ${({ theme }) => theme.spacing[2]};
  }
`;

export const MobileSide: React.FC<IMobileSide> = ({ onMenuClick }) => {
  return (
    <StyledMobileSide>
      <img src={czoLogo} alt="" />
      <StyledMobileMenu>
        <Tools orientation="vertical" exclude={['Fullscreen']} />
        <ToolsItem
          title="Menu"
          onClick={onMenuClick}
          icon={<FontAwesomeIcon size="lg" icon={faBars} />}
        />
      </StyledMobileMenu>

    </StyledMobileSide>
  );
};